import DashboardLayout from '../components/DashboardLayout';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
import { Construction } from 'lucide-react';

/**
 * FitnessDashboard — "606 فتنس (التحكم)" from the Control & Info hub.
 * Intentionally empty for now — the user will define its cards later.
 */
export default function FitnessDashboard() {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const isAr = language === 'ar';

  const backTarget = '/dashboard?view=platform-control';

  return (
    <DashboardLayout
      title="606 فتنس (التحكم)"
      titleEn="606 FITNESS (Control)"
      subtitle=""
      subtitleEn=""
      screenCode="FIT-000"
      backPath={backTarget}
      onBack={() => navigate(backTarget)}
      breadcrumb={[
        { labelAr: 'التحكم والمعلومات', labelEn: 'Control & Info', path: backTarget },
        { labelAr: '606 فتنس (التحكم)', labelEn: '606 FITNESS (Control)' },
      ]}
    >
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center py-20"
          data-testid="fitness-control-coming-soon"
        >
          <div className="w-24 h-24 mx-auto mb-6 rounded-2xl bg-white/[0.02] border border-white/10 flex items-center justify-center">
            <Construction className="w-12 h-12 text-emerald-400/60" />
          </div>
          <h3 className="text-2xl font-bold text-[#F5F5F5] mb-2">
            {isAr ? 'قريباً' : 'Coming Soon'}
          </h3>
          <p className="text-[#71717A] text-sm">
            {isAr ? 'هذا القسم قيد التجهيز' : 'This section is being prepared'}
          </p>
        </motion.div>
      </section>
    </DashboardLayout>
  );
}
